import { render, staticRenderFns } from "./randomPaperUs.vue?vue&type=template&id=d676c7fe&"
import script from "./randomPaperUs.vue?vue&type=script&lang=ts&"
export * from "./randomPaperUs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports